<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn class=float-right dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card-text>
            <v-row>
                <v-simple-table class="elevation-1" style="width: 100%">
                <template v-slot:top>
                    <v-toolbar flat dense class="table-head-background">
                    <v-toolbar-title>Common Application Form</v-toolbar-title>
                    <v-spacer></v-spacer>
                    </v-toolbar>
                </template>
                <template v-slot:default>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-autocomplete 
                                    dense
                                    outlined
                                    prepend-inner-icon="mdi-view-list"
                                    label="Academic Year"
                                    v-model="academicyear" 
                                    :items="ayList"
                                    item-value="id"
                                    item-text="ay"
                                    persistent-hint
                                    :rules="[(v) => !!v || 'Compulsory']"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <div class="col-sm-12">
                            <label>All/Date Range<span style="color:red;font-size:12px;font-style:bold;">*</span> : </label>
                        </div>
                        <div id="Range" style="border: 2px solid #034c70;">
                            <div class="row d-flex">
                                <div style="margin-left: 30px;margin-top: 10px;" class="col-sm-4">
                                    From Date:<label style="color:red;font-size:12px;font-style:bold;">*</label>
                                    <input type="date" class="form-control" v-model="fromdate" id="fromdate">
                                </div>
                                <div style="margin-top: 10px;" class="col-sm-4">
                                    To Date:<label style="color:red;font-size:12px;font-style:bold;">*</label>
                                    <input type="date" class="form-control " v-model="todate" id="todate">
                                </div><br><br><br><br>
                            </div>
                        </div>
                        <br />
                        <center>
                            <v-btn color="primary" dark class="mb-2" @click="fetchCommonApplicationForm()" :loading="saving">Fetch</v-btn>
                        </center>
                    </v-card-text>
                </template>
                </v-simple-table>
            </v-row>
        </v-card-text>
        <v-spacer></v-spacer>
        <v-card-text v-if="admission_application_list!=''">
            <v-row>
               <!-- <v-simple-table class="elevation-1" style="width: 100%">
                    <template v-slot:top>
                        <v-toolbar flat dense color="white">
                        <v-toolbar-title>Common Application Forms</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <download-excel :data="admission_application_list" :fields="table_fields" worksheet="admission_application_list" type="csv" name="Preadmission_common_application_list.xls">
                            <button class="btn btn-green-outline icon-color "><v-icon class="icon-color">mdi-file-excel</v-icon> Export</button>
                        </download-excel>
                        <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-simple-table style="border: 1px solid black">
                            <template v-slot:default>
                                <thead style="background-color: #fcc96f;">
                                <tr>
                                    <th>Sr.No</th>
                                    <th>Name Of Institute</th>
                                    <th>Program Type</th>
                                    <th>Course</th>
                                    <th>1st Year Count</th>
                                    <th>2nd Year Count</th>
                                </tr>
                                </thead>
                                <tbody v-for="(item, index) in admission_application_list" :key="index">
                                    <tr style="font-weight: 600">
                                        <td>{{ item.cri_srNo }}</td>
                                        <td >{{ item.institute }}</td>
                                        <td>{{ item.program_type }}</td>
                                        <td>{{ item.course }}</td>
                                        <td>{{ item.FE_count }}</td>
                                        <td>{{ item.SE_count }}</td>
                                    </tr>
                                </tbody>
                            </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-simple-table>-->
                <div class="container">
                    <v-data-table
                        :headers="headers"
                        :items="admission_application_list"
                        class="elevation-1"
                        :search="search"
                    >
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-toolbar-title>Common Application Forms</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <download-excel  :data="admission_application_list" :fields="table_fields" worksheet="admission_application_list" type="csv" name="Preadmission_application_list.xls">
                                    <button class="btn btn-green-outline icon-color "><v-icon class="icon-color">mdi-file-excel</v-icon> Export</button>
                                </download-excel>
                                <v-spacer></v-spacer>
                                <v-text-field
                                    v-model="search"
                                    append-icon="search"
                                    label="Search"
                                    single-line
                                    hide-details
                                    class="mobile-dashboard-search"
                                ></v-text-field>
                                <span style="width: 20px"></span>
                            </v-toolbar>
                        </template>
                        
                        <template v-slot:[`item.isActive`]="{ item }">
                            <span v-if="item.isActive">
                                <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                            </span>
                            <span v-else>
                                <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                            </span>
                        </template>
                        <template v-slot:[`item.action`]="{ item }">
                            <div>
                            <v-avatar style size="25" class="edit-avatar">
                                <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                            </v-avatar>
                            </div>
                        </template>
                    </v-data-table>
                </div>
            </v-row>
        </v-card-text>
    </div>
</template>
<script>
import "@/assets/css/styles.css";
import axios from "axios";
export default {
  name: "CommonApplicationForm",
  components:{},
  data: () => ({
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    error:"",
    saving:false,
    programTypeList:[],
    ayList:[],
    admission_application_list:[],
    academicyear:"",
    fromdate:"",
    todate:"",
    table_fields: {
        "Sr.No": "cri_srNo",
        "Name Of Institute": "institute",
        "Program Type": "program_type",
        "Course": "course",
        "1st Year Count": "FE_count",
        "2nd Year Count": "SE_count",
    }, 
    headers: [
        { 
            text: "Sr.No", 
            value: "cri_srNo" 
        },
        {
            text: "Name Of Institute",
            align: "left",
            sortable: true,
            value: "institute"
        },
        {
            text: "Program Type",
            align: "left",
            sortable: true,
            value: "program_type"
        },
        {
            text: "Course",
            align: "left",
            sortable: true,
            value: "course"
        },
        {
            text: "1st Year Count",
            align: "left",
            sortable: true,
            value: "FE_count"
        },
        {
            text: "2nd Year Count",
            align: "left",
            sortable: true,
            value: "SE_count"
        },
    ],
  }),
  methods: {
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },//end Of Function
    fetchData() {
        const data = {
            application_id: localStorage.getItem("loginid"),
        };
        axios
        .post("/Instructor/fetchCommonApplicationForm", data)
        .then((res) => {
            if (res.data.status == "200") {
                this.ayList = res.data.ayList;
                this.academicyear = res.data.aay;
                this.fromdate = res.data.date;
                this.todate = res.data.date;
            }
            else if (res.data.status == "501") {
                this.showSnackbar("#b71c1c", res.data.msg);
            }
        })
        .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong.Please try again.");
        })
        .finally(() => {
            //'use strict';
        });
    },//end of function
    fetchCommonApplicationForm() {
        this.saving = true;
        if(!this.fromdate && !this.todate){
            this.showSnackbar("#b71c1c", "Please Select Date Range");
            this.saving = false;
            return
        }
        const data = {
            academicyear: this.academicyear,
            fromdate: this.fromdate,
            todate: this.todate,
            login_id: localStorage.getItem("loginid"),
        };
        axios
        .post("/Instructor/fetchCommonApplicationReport", data)
        .then((res) => {
            this.saving = false;
            if (res.data.status == "200") {
                this.admission_application_list = res.data.final_application_list;
                //alert("admission_application_list >>"+ res.data.admission_application_list)
                if(res.data.admission_application_list==""){
                    this.showSnackbar("#b71c1c", "Data Not Available");
                } 
            }
            else if (res.data.status == "501") {
                this.showSnackbar("#b71c1c", res.data.msg);
            }
        })
        .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong.Please try again.");
            this.saving = false;
        })
    },//end of function
  },
  watch: {},
  mounted(){
    this.fetchData();
  }
};
</script>
<style scoped>
    .table-head-background {
        background-image: linear-gradient(-90deg, #fcc96f, #fcb63c);
        color: #fff;
        font-weight: 700;
    }
    .btn.btn-green-outline {
        padding: 6px 15px;
        background-color: #bde9ba;
        border-color: #003400;
        color: #ffffff;
        border-radius: 4px;
    }
    .btn.btn-green-outline:hover {
        background-color: #ffffff;
        border: 2px solid #003400;
        border-radius: 4px;
        color: #003400;
    }
</style>
